"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TicketFilter = /** @class */ (function () {
    function TicketFilter() {
    }
    return TicketFilter;
}());
exports.TicketFilter = TicketFilter;
